import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import { Save, Clear, Warning } from '@material-ui/icons';
import Snackbar from "components/Snackbar/Snackbar.jsx";
// @material-ui/icons
import Close from "@material-ui/icons/Close";
// core components
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import modalStyle from "assets/jss/material-kit-pro-react/modalStyle.jsx";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

class ModalEliminarCuenta extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      correoConfirmacion: "",
      errorCorreo: false,
      mensaje: "",
      colorNotificacion: "",
      br: false
    };
  }

  escFunction(event) {
    if (event.keyCode === 27) {
      this.props.eventClick(false);
    }
  }

  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

  handleChange = (e) => {
    const { value } = e.target;
    this.setState({
      correoConfirmacion: value,
      errorCorreo: false
    });
  }

  showNotification(mensaje, color) {
    var x = [];
    this.setState({ br: true, mensaje: mensaje, colorNotificacion: color });
    this.setState(x);
    this.alertTimeout = setTimeout(
      function () {
        this.setState({ br: false });
        this.setState(x);
      }.bind(this),
      3000
    );
  }

  validarYConfirmar = () => {
    const { correoConfirmacion } = this.state;
    const { correoUsuario } = this.props;

    if (!correoConfirmacion || correoConfirmacion.trim() === "") {
      this.setState({ errorCorreo: true });
      this.showNotification("Por favor, ingresa tu correo electrónico", "danger");
      return;
    }

    if (correoConfirmacion.trim().toLowerCase() !== correoUsuario.toLowerCase()) {
      this.setState({ errorCorreo: true });
      this.showNotification("El correo ingresado no coincide con tu correo registrado", "danger");
      return;
    }

    // Si la validación es exitosa, llamar a la función de confirmación
    this.props.eventClick(true);
  }

  render() {
    const { classes, open, correoUsuario } = this.props;
    const { correoConfirmacion, errorCorreo } = this.state;

    return (
      <div>
        <Dialog
          classes={{
            root: classes.modalRoot,
            paper: classes.modal
          }}
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => this.props.eventClick(false)}
          aria-labelledby="classic-modal-slide-title"
          aria-describedby="classic-modal-slide-description"
        >
          <DialogTitle
            id="classic-modal-slide-title"
            disableTypography
            className={classes.modalHeader}
          >
            <Button
              simple
              className={classes.modalCloseButton}
              key="close"
              aria-label="Close"
              onClick={() => this.props.eventClick(false)}
            >
              {" "}
              <Close className={classes.modalClose} />
            </Button>
            <h4 className={classes.modalTitle} style={{ color: "#f44336" }}>
              <Warning style={{ verticalAlign: "middle", marginRight: "8px" }} />
              Eliminar cuenta
            </h4>
          </DialogTitle>
          <DialogContent id="classic-modal-slide-description" className={classes.modalBody}>
            <div style={{ marginBottom: "20px" }}>
              <p style={{ fontSize: "16px", fontWeight: "500", marginBottom: "15px" }}>
                Esta acción es <strong style={{ color: "#f44336" }}>irreversible</strong> y eliminará permanentemente:
              </p>
              <ul style={{ marginLeft: "20px", marginBottom: "15px" }}>
                <li>Todos tus datos personales</li>
                <li>Tu historial de compras y ventas</li>
                <li>Tus diseños guardados</li>
                <li>Tu información de membresía</li>
                <li>Todos los demás datos asociados a tu cuenta</li>
              </ul>
              <p style={{ fontSize: "14px", color: "#666", marginBottom: "20px" }}>
                Si estás seguro de que deseas continuar, por favor escribe tu correo electrónico para confirmar:
              </p>
            </div>
            <CustomInput
              labelText="Correo electrónico"
              id="correoConfirmacion"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                value: correoConfirmacion,
                onChange: this.handleChange,
                type: "email",
                error: errorCorreo
              }}
              error={errorCorreo}
            />
            {errorCorreo && (
              <p style={{ color: "#f44336", fontSize: "12px", marginTop: "5px" }}>
                El correo debe coincidir con tu correo registrado
              </p>
            )}
          </DialogContent>
          <DialogActions className={classes.modalFooter}>
            <Button 
              onClick={this.validarYConfirmar} 
              size="sm" 
              color="danger" 
              className="pull-right" 
              round
              disabled={!correoConfirmacion || correoConfirmacion.trim() === ""}
            >
              <Save />&nbsp;Sí, eliminar cuenta
            </Button>
            <Button 
              size="sm" 
              color="github" 
              className="pull-right" 
              round 
              onClick={() => this.props.eventClick(false)}
            >
              <Clear />&nbsp;Cancelar
            </Button>
          </DialogActions>
        </Dialog>
        <div id="">
          <Snackbar
            place="tr"
            color={this.state.colorNotificacion}
            message={this.state.mensaje}
            open={this.state.br}
            closeNotification={() => this.setState({ br: false })}
            close
          />
        </div>
      </div>
    );
  }
}

export default withStyles(modalStyle)(ModalEliminarCuenta);
